import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TabelaEnderecoProps } from '../../../../../interfaces/props/Cancelamento/TabelaEnderecoProps';
import { cepMask } from '../../../../../utils/CepMask';
import './styles.css';
import { sxTable } from './sxProps';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';

const TabelaEndereco: React.FC<TabelaEnderecoProps> = ({ data, toggleIdEnderecoSelecionado, idEnderSelecionado }) => {

  const { textStyleAccessibility, contrastBorderAccessibility, contrastColorAccessibility } = useAccessibility();

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    ...{
      fontFamily: 'Unimed-Sans',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
    },
    ...textStyleAccessibility
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: '#F9F9F9'
    },
  }));

  return (
    <div>
      <TableContainer className='container-table' sx={sxTable} style={contrastBorderAccessibility} component={Paper}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <StyledTableCell padding="checkbox">
                <Checkbox
                  color="primary"
                  style={contrastColorAccessibility}
                  indeterminate={false}
                  disabled
                />
              </StyledTableCell>
              <StyledTableCell><b>Logradouro</b></StyledTableCell>
              <StyledTableCell align="left"><b>Número</b></StyledTableCell>
              <StyledTableCell align="left"><b>Complemento</b></StyledTableCell>
              <StyledTableCell align="left"><b>Bairro</b></StyledTableCell>
              <StyledTableCell align="left"><b>CEP</b></StyledTableCell>
              <StyledTableCell align="left"><b>Cidade</b></StyledTableCell>
              <StyledTableCell align="left"><b>Estado</b></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row, index) => (
              <StyledTableRow
                key={index}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <StyledTableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    style={contrastColorAccessibility}
                    checked={idEnderSelecionado === row.idEnderPostal}
                    onChange={(e) => toggleIdEnderecoSelecionado(index)}
                  />
                </StyledTableCell>
                <StyledTableCell component="th" scope="row" sx={{ minWidth: '185px' }}> {row.logradouro} </StyledTableCell>
                <StyledTableCell align="left">{row.numero || '-'}</StyledTableCell>
                <StyledTableCell align="left">{row.complemento || '-'}</StyledTableCell>
                <StyledTableCell align="left">{row.bairro || '-'}</StyledTableCell>
                <StyledTableCell align="left">{cepMask(row.cep.cep) || '-'}</StyledTableCell>
                <StyledTableCell align="left">{row.cidade.descrCidade || '-'}</StyledTableCell>
                <StyledTableCell align="left">{row.cidade.uf.siglaUf || '-'}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default TabelaEndereco;